import React, { forwardRef } from 'react';
import { FormField } from '../FormField.tsx';

export interface SelectOption {
  value: string | number;
  label: string;
}

export interface SelectInputProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, 'className'> {
  label?: string;
  error?: string;
  required?: boolean;
  hint?: string;
  options: SelectOption[];
  placeholder?: string;
}

const inputClassName = (error?: string) =>
  `w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 disabled:bg-gray-50 ${
    error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
  }`;

export const SelectInput = forwardRef<HTMLSelectElement, SelectInputProps>(
  ({ label, error, required, hint, id, options, placeholder, ...rest }, ref) => (
    <FormField label={label} error={error} required={required} hint={hint} htmlFor={id}>
      <select
        ref={ref}
        id={id}
        className={inputClassName(error)}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : hint ? `${id}-hint` : undefined}
        {...rest}
      >
        {placeholder !== undefined && (
          <option value="">{placeholder}</option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </FormField>
  )
);

SelectInput.displayName = 'SelectInput';
